// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.status-chip {
    font-weight: 500;
}

.status-chip-released {
    background-color: #fff;
    color: #101120;
    border-color: #101120;
}

.status-chip-new-release {
    background-color: #4caf50;
    color: #000;
}

.status-chip-in-progress {
    background-color: #2196f3;
    color: #fff;
}

.status-chip-planned {
    background-color: #ff9800;
    color: #fff;
}

.status-chip-under-consideration {
    background-color: #9c27b0;
    color: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/components/grid/StatusChip.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf","sourcesContent":[".status-chip {\n    font-weight: 500;\n}\n\n.status-chip-released {\n    background-color: #fff;\n    color: #101120;\n    border-color: #101120;\n}\n\n.status-chip-new-release {\n    background-color: #4caf50;\n    color: #000;\n}\n\n.status-chip-in-progress {\n    background-color: #2196f3;\n    color: #fff;\n}\n\n.status-chip-planned {\n    background-color: #ff9800;\n    color: #fff;\n}\n\n.status-chip-under-consideration {\n    background-color: #9c27b0;\n    color: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
